import styled from 'styled-components';

export const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid gray;

  .address-selected {
    flex: 1;
    & p:nth-child(1) {
      line-height: 20px;
      font-size: 16px;
      font-weight: 500;
    }
  }
`;

export const StyledLabel = styled.label`
  font-weight: bold;
  font-size: 14px;
  font-family: inherit;
  margin-bottom: 4px;
  display: block;
  line-height: 20px;
`;

export const StyledInput = styled.input`
  border-radius: 2px;
  width: 100%;
  border: 1px solid #646569;
  padding: 0.5rem 1rem;
  height: 48px;
  outline: none;

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(31, 30, 30, 0.35);
  }
`;

export const AddressSecondaryInfo = styled.p`
  font-size: 14px;
`;

export const StyledWrapperInputAutocomplete = styled.div`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
`;
